import {Button, Input} from '@priority-software/priority-style-react';
import React, {useState, KeyboardEvent} from 'react';

import {getLocalizedText, texts} from '../../../../../constants/TextConst';
import {handleSpreadSheetPaste, spreadSheetProps} from '../../../../../utils/paste';
import {createDataTestId} from '../../../../../utils/dataTestId';

interface Props {
    onUpdateFilter: (value: string | string[]) => void;
    isDisabled: boolean;
}

const TextControl = ({onUpdateFilter, isDisabled}: Props) => {
    const [value, setValue] = useState('');

    const handleChange = e => {
        setValue(e.target.value);
    };

    const handleUpdate = () => {
        onUpdateFilter(value);
        setValue('');
    };

    const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (e.key === 'Enter') {
            handleUpdate();
        }
    };

    const handleSpreadsheetValues = (parsedSpreadSheet: spreadSheetProps) => {
        const {values} = parsedSpreadSheet;
        onUpdateFilter(values);
    };

    const handlePaste = event => {
        return handleSpreadSheetPaste(event, handleChange, handleSpreadsheetValues);
    };

    return (
        <Input
            //TO DO : add this prop to lib style
            {...createDataTestId('text-control-filter-box', true)}
            size="medium"
            value={value}
            direction="auto"
            onChange={handleChange}
            onPaste={handlePaste}
            disabled={isDisabled}
            onKeyDown={onKeyDown}
            inlinePadding="start"
            autoFocus
        >
            {value && (
                <Button
                    componentClasses="add-button"
                    onClick={handleUpdate}
                    {...createDataTestId('text-control-button-filter-box', true)}
                >
                    {getLocalizedText(texts.addButton)}
                </Button>
            )}
        </Input>
    );
};

export default TextControl;
